const LinkRenderer: React.FC<{ href?: string, children: any }> = ({ href, children }) => {
    return (
        <a href={href} target="_blank" rel="noopener noreferrer">
            {children}
        </a>
    );
};
export default LinkRenderer;
